//提现列表广告
import withdrawalListImg from '@/assets/info/output-with.png'
export const WITHDRAWAL_LIST_IMG_URL = withdrawalListImg
export const WITHDRAWAL_LIST_URL =
  'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025072502'
